import type { ApiGenericResponse, CreateOrderPayload, Order, OrderPayment } from '../../typings'

export function createOrderAction<
  T = ApiGenericResponse<{
    order: Order
    payment: OrderPayment
  }>,
>(payload: CreateOrderPayload): Promise<T> {
  const { api } = useApi()
  return api.post<T>('/v2/orders', payload)
}
